module.exports = __webpack_public_path__ + "static/media/kiwi-picker-robotics.7b53b576.jpg";